import React from 'react';
import { useToast } from '../../hooks/use-toast';
import { X } from 'lucide-react';

export function Toaster() {
  const { toasts, dismiss } = useToast();

  return (
    <div className="fixed top-4 right-4 z-50 space-y-2">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`p-4 rounded-lg shadow-lg max-w-md transform transition-all duration-300 border ${
            toast.variant === 'destructive' 
              ? 'bg-red-600 border-red-500 text-white' 
              : 'bg-gray-800 border-violet-500/20 text-white'
          } ${toast.open ? 'animate-slide-in' : 'animate-slide-out'}`}
        >
          <div className="flex items-start justify-between">
            <div>
              {toast.title && (
                <h4 className="font-semibold mb-1">{toast.title}</h4>
              )}
              {toast.description && (
                <p className="text-sm opacity-90">{toast.description}</p>
              )}
            </div>
            <button
              onClick={() => dismiss(toast.id)}
              className="ml-2 text-white/60 hover:text-white transition-colors"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}

// Simple provider wrapper - not needed since the hook manages state globally
export function ToastProvider({ children }) {
  return children;
}
